var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notifications)?_c('span',{staticClass:"badge-count"},[_vm._v(" "+_vm._s(_vm.notifications > 99 ? '99+' : _vm.notifications)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }